var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import getMessage from 'src/background/utils/i18n.utils';
import { setTitleContainerProperties } from '@popup/multichain/actions/title-container.actions';
import { LocalStorageKeyEnum } from '@reference-data/local-storage-key.enum';
import { Screen } from '@reference-data/screen.enum';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { CheckboxPanelComponent } from 'src/common-ui/checkbox/checkbox-panel/checkbox-panel.component';
import LocalStorageUtils from 'src/utils/localStorage.utils';
const Keychainify = ({ setTitleContainerProperties }) => {
    const [enabled, setEnabled] = useState(false);
    useEffect(() => {
        setTitleContainerProperties({
            title: 'popup_html_keychainify',
            isBackButtonEnabled: true,
        });
        init();
    }, []);
    useEffect(() => {
        const saveEnabled = () => __awaiter(void 0, void 0, void 0, function* () {
            yield LocalStorageUtils.saveValueInLocalStorage(LocalStorageKeyEnum.KEYCHAINIFY_ENABLED, enabled);
        });
        saveEnabled();
    }, [enabled]);
    const init = () => __awaiter(void 0, void 0, void 0, function* () {
        setEnabled(yield LocalStorageUtils.getValueFromLocalStorage(LocalStorageKeyEnum.KEYCHAINIFY_ENABLED));
    });
    return (React.createElement("div", { "data-testid": `${Screen.SETTINGS_KEYCHAINIFY}-page`, className: "keychainify-page" },
        React.createElement("div", { className: "intro" }, getMessage('popup_html_keychainify_text')),
        React.createElement("div", { className: "fields" },
            React.createElement(CheckboxPanelComponent, { dataTestId: "checkbox-keychainify", title: "popup_html_enable_keychainify_title", checked: enabled, onChange: setEnabled, hint: "popup_html_enable_keychainify_info" }))));
};
const mapStateToProps = (state) => {
    return {};
};
const connector = connect(mapStateToProps, { setTitleContainerProperties });
export const KeychainifyComponent = connector(Keychainify);
